import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: initial;
  width: 100%;
  height: 90%;
  margin: 0 auto;
  padding: 0;
  background-color: transparent;
  margin: 0;
  @media only screen and (min-width: 768px) {
    height: 100%;
  }
`;
export const Article = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  color: gray;
  display: flex;
  flex-direction: column;
  align-items: center;
  .img-container {
    width: 100%;
    height: 90%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    img {
      width: 90%;
      height: auto;
    }
  }
  h1,
  p {
    width: 100%;
    padding: 0;
    text-align: center;
  }
  h1 {
    font-size: 1.3rem;
    padding: 1rem 0 0 0;
  }
  a {
    font-weight: 800;
    color: gray;
    text-decoration: none;
  }
  p {
    font-size: 13px;
  }
  @media only screen and (min-width: 768px) {
    p {
      padding: 1rem 0 0 0;
      font-size: 14px;
    }
    .img-container {
      height: 50%;
      img {
        width: 95%;
        height: auto;
      }
    }
  }
  @media only screen and (min-width: 1024px) {
    p {
      font-size: 16px;
    }
  }
`;
